export default __webpack_public_path__ + "static/media/advantage-3.38d4d8ea.png";